'use client';
import ButtonGrid from './button_grid/ButtonGrid';
import ColumnSelector from './column/ColumnSelector';
import Dropdown from './dropdown/Dropdown';
import Swatches from './swatches/Swatches';
import { readSelectorSettings } from './selector-settings';

const SELECTORS = {
  button_grid: ButtonGrid,
  column: ColumnSelector,
  dropdown: Dropdown,
  swatches: Swatches
};

/**
 * Picks which of the variant selector types to render based on CS settings.
 */
export default function VariantSelector({ block, position }) {
  const { selectorType } = readSelectorSettings(block);
  const Selector = SELECTORS[selectorType];

  if (!Selector) {
    return <div className="empty-component">{selectorType} Variant Option</div>;
  }

  return <Selector block={block} position={position} />;
}
